import { JetView } from 'webix-jet';

/**
 * Class representing a view for details of auto-exclusion users.
 * @extends JetView
 */
export default class detailsAutoexclusionUsersView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const left = {
            view: 'toolbar', // Toolbar component
            rows: [
                {
                    view: 'toolbar',
                    css: theme, // Apply theme to the toolbar
                    elements: [{ view: 'label', label: _('Detalles') }], // Label for the toolbar
                },
            ],
        };
        return {
            type: 'wide', // Layout type
            cols: [left], // Columns configuration
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component (not used in this fragment).
     */
    init(grid) {
        this.on(this.app, 'user:id', (idUser) => {
            // Event listener for user ID changes (empty implementation)
        });
    }
}

// FILE DOCUMENTED
